/** @type {import("./homeCopy.types").HomeCopy} */
const homeCopyUpdated = {
    promoBar:
        "Licensed Private Hire cars · Weekly hire from our North East office · Start earning sooner",
    hero: {
        overline: "Private Hire cars · North East",
        headline: "Get a licensed car and start earning on Uber & Bolt",
        subheadline:
            "Weekly hire on licensed Private Hire vehicles — clear pricing, local support, and cars ready for the platforms you already use. Collect from our Blaydon office.",
    },
    trustStrip: {
        title: "Local, licensed vehicles",
        subtitle: "Ready for Uber & Bolt across the North East",
    },
    whatsIncluded: {
        intro:
            "We hire licensed Private Hire vehicles to licensed drivers — weekly payments, local support, and cars ready to earn on the platforms you already use.",
        benefits: [
            {
                title: "Clear weekly pricing",
                body: "See the weekly cost before you enquire — no hidden fees, no ownership finance, just straightforward hire paid each week.",
            },
            {
                title: "Weekly hire, flexible exit",
                body: "Pay weekly and keep earning. If your plans change, give two weeks' written notice and return the car to our Blaydon office.",
            },
            {
                title: "Insurance your way",
                body: "Use our fleet insurance or arrange your own fully comprehensive cover — whatever gets you earning sooner.",
            },
            {
                title: "Servicing & breakdown cover",
                body: "MOT, servicing, and breakdown cover included, so you spend less time off the road and more time earning.",
            },
            {
                title: "Licensed & platform-ready",
                body: "Every car is licensed for Private Hire work and matched to the right council for your PHV driver licence.",
            },
            {
                title: "Local North East team",
                body: "Talk to real people at our Blaydon office — call, enquire, collect, and get back to earning.",
            },
        ],
    },
    availableCars: {
        subheading:
            "Browse licensed Private Hire cars available to hire. Each listing shows the weekly price, licensing council, and what's included — so you can choose a car that matches your PHV driver licence.",
    },
    carCard: {
        hireBadge: "Licensed for Private Hire",
    },
    contact: {
        dark: {
            description:
                "Enquire about hiring a Private Hire vehicle, ask what's included, or arrange a collection from our Blaydon office.",
        },
        light: {
            description:
                "Call, email, or send a message — we'll help you find the right Private Hire car for the North East.",
        },
        formSubheading:
            "Tell us which car you're interested in and we'll get back to you with the next steps.",
    },
    footer: {
        tagline:
            "Licensed Private Hire vehicles for licensed drivers across the North East. Weekly hire, clear pricing, local support.",
    },
    whatsapp: {
        chatPrompt: "Hi! I'd like to ask about hiring a Private Hire vehicle.",
    },
    meta: {
        description:
            "Weekly hire on licensed Private Hire cars across the North East for Uber and Bolt drivers — from Stargate Rentals in Blaydon.",
    },
}

export default homeCopyUpdated
